<div
  class="basin-width-100 basin-display-flex basin-flex-row basin-align-items-center basin-justify-content-space-between"
  *ngIf="simulationTracker"
>
  <div class="basin-width-100 basin-font-size-14">
    {{ simulationTracker.statusUpdated | date: 'MMMM d, y, h:mm a'  }}
  </div>
  <div
    [ngClass]="getStatusColorClass(simulationTracker)"
    class="basin-font-uppercase basin-text-align-right basin-font-weight-500 basin-font-size-14 basin-white-space-nowrap"
  >
    {{ getStatusMessage(simulationTracker) }}
  </div>
</div>
